import { Component } from '@angular/core';
import { ErrorNotificationComponent } from '@components/error-notification/error-notification.component';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-consultation-error-page',
  templateUrl: './consultation-error-page.component.html',
  imports: [ErrorNotificationComponent],
})
export class ConsultationErrorPageComponent {
  /**
   * Gets the contact email.
   */
  public get contactEmail(): string {
    return environment.email;
  }
}
